if (!('IntersectionObserver' in window)) {
  import('intersection-observer')
}
